/* eslint-disable react/no-danger */
import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { motion } from 'framer-motion';
import useMediaQuery from '../hooks/useMediaQuery';
import Sprites from '../components/Sprites';
import { getTranslationByKey } from '../helpers/translation-helper';
import { DWTCContext } from '../utils/context';

function FreeZoneFaq({ id, data }) {
  const title = _.get(data, 'title', '');
  const faqItems = _.get(data, 'faqItems', []);
  const [selected, setSelected] = useState([]);
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const { translations } = useContext(DWTCContext);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredFaqItems, setFilteredFaqItems] = useState([]);

  const handleClick = (key, items, index) => {
    if (selected[0] === key) setSelected([]);
    else setSelected([key, items, index]);
  };

  const chuckedSm = _.chunk(_.toPairs(_.groupBy(faqItems, 'content.category')), 2);
  const chuckedLg = _.chunk(_.toPairs(_.groupBy(faqItems, 'content.category')), 5);

  const [activeIndex, setActiveIndex] = useState(0);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // useEffect(() => {
  //   if (faqItems.length > 0) {
  //     const firstKey = _.get(chuckedSm[0][0], '0');
  //     const firstItems = _.get(chuckedSm[0][0], '1');
  //     if (firstKey && firstItems) {
  //       setSelected([firstKey, firstItems, 0]);
  //     }
  //   }
  // }, [faqItems]);

  useEffect(() => {
    if (searchTerm) {
      const filtered = faqItems
        .map((item) => {
          const matchingFaqsQuestionAnswerItem = item?.content?.faqsQuestionAnswerItem?.filter(
            (qa) =>
              qa?.content?.faqQuestion?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
              qa?.content?.faqAnswer?.toLowerCase()?.includes(searchTerm?.toLowerCase()),
          );

          const matchingFaqsListItem = item?.content?.faqsListItem
            ?.map((listItem) => {
              const matchingItemFaqs = listItem?.content?.itemFaqQuestionAnswer?.filter(
                (qa) =>
                  qa?.content?.faqQuestion?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                  qa?.content?.faqAnswer?.toLowerCase()?.includes(searchTerm?.toLowerCase()),
              );

              if (matchingItemFaqs?.length > 0) {
                return {
                  ...listItem,
                  content: { ...listItem.content, itemFaqQuestionAnswer: matchingItemFaqs },
                };
              }
              return null;
            })
            .filter((listItem) => listItem !== null);

          if (matchingFaqsQuestionAnswerItem?.length > 0 || matchingFaqsListItem?.length > 0) {
            return {
              ...item,
              content: {
                ...item.content,
                faqsQuestionAnswerItem: matchingFaqsQuestionAnswerItem,
                faqsListItem: matchingFaqsListItem,
              },
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      setFilteredFaqItems(filtered);
    } else {
      setFilteredFaqItems(faqItems);
    }
  }, [searchTerm, faqItems]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm('');
  };

  const highlightText = (text, highlight) => {
    if (!highlight) return text;
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

    return parts
      .map((part, index) =>
        part.toLowerCase() === highlight.toLowerCase()
          ? `<span key=${index} class="bg-yellow-200">${part}</span>`
          : part,
      )
      .join('');
  };

  return (
    <section id={id} className="relative bg-desertStorm">
      <div className="container mx-auto relative xl:max-w-[1470px] sm:px-0 px-6 md:px-4 2xl:px-0">
        <div className="w-full py-12 md:py-16 lg:py-20 xl:py-25 flex flex-col items-center">
          <div className="flex flex-col gap-y-5 pb-12">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40 p-child:text-clamp20to40 p-child:!text-[#231F20]
              p-child:leading-1.2 text-center p-child:m-0 p-child:ltr:font-URWDINMedium
              child:rtl:!font-GESSTwoDWTCMedium"
            />
            <div className="h-[2px] w-[70px] bg-[#CE445B] mx-auto" />
          </div>
          <div
            className="w-full sm:w-auto flex flex-col sm:flex-row items-center 
                gap-6 md:gap-10 lg:justify-items-center lg:justify-center pb-8 lg:pb-20">
            <input
              placeholder={getTranslationByKey(translations, 'Search for a question')}
              value={searchTerm}
              onChange={handleSearch}
              className="py-3.5 px-5 w-full text-[#4D4D4D]
                    h-10 md:h-[55px] flex justify-center text-[13px] md:text-[15px] 
                    ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight
                    !placeholder-[#4D4D4D] border border-[#979797]
                    rtl:text-[12px] rtl:md:text-[15px] w-[calc(100% - 160px)] sm:min-w-[570px]"
            />
            <button
              type="button"
              className="py-3 pt-[10px] md:pt-4 px-12 md:px-14 transition-[.3s] bg-red 
                      hover:bg-[#B53B50] rounded-full h-8 md:h-[51px] min-h-[40px]
                      text-white uppercase tracking-widest 
                      ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium
                      w-full text-[11px] md:text-[15px]">
              {getTranslationByKey(translations, 'Search')}
            </button>
            {searchTerm ? (
              <button
                type="button"
                onClick={clearSearch}
                className="flex flex-row gap-[10px]
              ltr:font-DINMedium rtl:font-URWDINMedium text-[#4a4a4a] text-clamp12to15 uppercase
              items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="none">
                  <path
                    d="M1 1.5L9 9.5M9 1.5L1 9.5"
                    stroke="#4A4A4A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span className="text-nowrap">
                  {getTranslationByKey(translations, 'Clear')}
                </span>
              </button>
            ) : (
              ''
            )}
          </div>
          {searchTerm ? (
            <div className="w-full">
              {filteredFaqItems.length > 0 ? (
                <div className="flex flex-col items-center gap-y-10 lg:gap-y-20 w-full">
                  <p className="!mb-0 ltr:font-DINMedium rtl:font-URWDINMedium text-[#4a4a4a] text-clamp12to20">
                    {getTranslationByKey(translations, 'Showing')}&nbsp; 
                    {filteredFaqItems.length} 
                    &nbsp;{getTranslationByKey(translations, 'results for the keyword')} {' '}
                    <span className="text-[#CE445B]">"{searchTerm}"</span>
                  </p>
                  <div className="w-full">
                    <div className="flex flex-col gap-5 lg:gap-y-14">
                      {filteredFaqItems.map((item, categoryIndex) => (
                        <div
                          key={categoryIndex}
                          className="flex flex-col gap-y-3 lg:gap-y-6 border
                        border-[#CE445B] p-10">
                          <h3
                            className="ltr:font-DINBold rtl:font-URWDINBold text-[#4a4a4a] text-clamp13to25
                          leading-1 font-bold">
                            {getTranslationByKey(translations, item.content.category)}
                          </h3>
                          {item.content.faqsQuestionAnswerItem?.length > 0 && (
                            <div className="flex flex-col gap-y-5 lg:gap-y-8 max-w-[1280px]">
                              {item.content.faqsQuestionAnswerItem.map((faq, faqIndex) => (
                                <div key={faqIndex} className="flex flex-col gap-y-3 lg:gap-y-4">
                                  <h5
                                    className="ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium text-clamp12to18
                                  text-[#58595b]"
                                    dangerouslySetInnerHTML={{
                                      __html: highlightText(faq.content.faqQuestion, searchTerm),
                                    }}
                                  />
                                  <div
                                    className="w-full flex flex-col items-start gap-3 text-[#58595B]
                                  [&>h5]:text-clamp13to18 ltr:[&>h4]:font-LibreBaskervilleRegular rtl:[&>h5]:font-GESSTwoDWTCMedium 
                                  [&>p]:text-clamp12to16 
                                  ul-child:ltr:pl-5 p-ul-child:ltr:pl-5 
                                  ul-child:rtl:pr-5 p-ul-child:rtl:pr-5 
                                  li-child:list-disc 
                                  p-li-child:list-disc p-child:text-[#4a4a4a] 
                                  ul-child:text-[#4a4a4a] p-child:font-URWDINRegular
                                  ul-child:font-URWDINRegular ul-child:text-clamp12to16
                                  li-child:pb-1 p-a-child:text-black 
                                  p-a-child:underline
                                  ul-a-child:underline
                                  hover:p-a-child:no-underline
                                  hover:ul-a-child:no-underline ul-child:mb-5 max-w-[1280px] p-child:!mb-0"
                                    dangerouslySetInnerHTML={{
                                      __html: highlightText(faq.content.faqAnswer, searchTerm),
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                          {item.content.faqsListItem?.length > 0 && (
                            <div className="flex flex-col gap-y-8">
                              {item.content.faqsListItem.map((listItem, listItemIndex) => (
                                <div key={listItemIndex} className="flex flex-col gap-y-4">
                                  {listItem.content.itemFaqQuestionAnswer?.map((qa, qaIndex) => (
                                    <div key={qaIndex} className="flex flex-col gap-y-4">
                                      <h5
                                        className="ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium text-clamp12to18
                                  text-[#58595b]"
                                        dangerouslySetInnerHTML={{
                                          __html: highlightText(qa.content.faqQuestion, searchTerm),
                                        }}
                                      />
                                      <div
                                        className="w-full flex flex-col items-start gap-3 text-[#58595B]
                                  [&>h5]:text-clamp13to18 ltr:[&>h4]:font-LibreBaskervilleRegular rtl:[&>h5]:font-GESSTwoDWTCMedium 
                                  [&>p]:text-clamp12to16 
                                  ul-child:ltr:pl-5 p-ul-child:ltr:pl-5 
                                  ul-child:rtl:pr-5 p-ul-child:rtl:pr-5 
                                  li-child:list-disc 
                                  p-li-child:list-disc p-child:text-[#4a4a4a] 
                                  ul-child:text-[#4a4a4a] p-child:font-URWDINRegular
                                  ul-child:font-URWDINRegular ul-child:text-clamp12to16
                                  li-child:pb-1 p-a-child:text-black 
                                  p-a-child:underline
                                  ul-a-child:underline
                                  hover:p-a-child:no-underline
                                  hover:ul-a-child:no-underline ul-child:mb-5 max-w-[1280px] p-child:!mb-0"
                                        dangerouslySetInnerHTML={{
                                          __html: highlightText(qa.content.faqAnswer, searchTerm),
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-center gap-y-20 w-full">
                  <p className="!mb-0 ltr:font-DINMedium rtl:font-URWDINMedium text-[#4a4a4a] text-clamp12to20">
                    {getTranslationByKey(translations, 'No results found for the keyword')} {' '}
                    <span className="text-[#CE445B]">"{searchTerm}"</span>
                  </p>
                </div>
              )}
            </div>
          ) : (
            <div className="w-full">
              <div className="w-full hidden lg:grid grid-cols-5 gap-7.5">
                {_.map(chuckedLg, (pair, index) => (
                  <>
                    {_.map(pair, ([key, items]) => (
                      <button
                        key={key}
                        type="button"
                        onClick={() => handleClick(key, items, index)}
                        className={`text-clamp12to18 
                      ltr:font-URWDINRegular 
                      rtl:font-GESSTwoDWTCLight min-h-47.5
                      tracking-tight leading-1.5 m-0 text-center px-9 py-5 relative
                      ${
                        selected[0] === key
                          ? 'bg-red text-white after:content[""] after:block after:w-0 after:h-0 ltr:after:ml-[-16px] after:absolute after:left-1/2 after:top-[calc(100%+30px)] after:border-l-[16px] after:border-l-transparent after:border-b-[14px] after:border-b-red after:border-r-[16px] after:border-r-transparent'
                          : 'bg-white text-red'
                      }`}>
                        <Sprites
                          name={items[0].content.iconName}
                          className={`${
                            selected[0] === key ? '[&>path]:stroke-white' : '[&>path]:stroke-red'
                          } w-10 h-10 mx-auto mb-3`}
                        />
                        {getTranslationByKey(translations, items[0].content.category)}
                      </button>
                    ))}
                    {!_.isEmpty(selected) && index === selected[2] && (
                      <div
                        className="gap-5 col-span-5 p-5 md:p-10 border border-red bg-white flex flex-col 
                    my-3 relative">
                        {_.map(selected[1], (item, index2) => {
                          const questionsAnswers = _.get(item, 'content.questionsAnswers', '');
                          const faqsQuestionAnswerItem = _.get(
                            item,
                            'content.faqsQuestionAnswerItem',
                            null,
                          );
                          const faqsListItem = _.get(item, 'content.faqsListItem', '');
                          return (
                            <React.Fragment key={index2}>
                              {_.isEmpty(faqsQuestionAnswerItem) || (
                                <div className="flex flex-col gap-y-3">
                                  {_.map(
                                    faqsQuestionAnswerItem,
                                    (faqsQuestionAnswerItemList, faqsQuestionAnswerItemIndex) => (
                                      <div
                                        className="flex flex-col gap-y-3"
                                        key={faqsQuestionAnswerItemIndex}>
                                        {faqsQuestionAnswerItemList?.content?.faqQuestion && (
                                          <h4
                                            className="text-[#58595B]
                                      text-clamp13to18 ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium ">
                                            {faqsQuestionAnswerItemList.content.faqQuestion}
                                          </h4>
                                        )}
                                        {faqsQuestionAnswerItemList?.content?.faqAnswer && (
                                          <div
                                            className="w-full flex flex-col items-start gap-3 text-[#58595B]
                                  [&>h4]:text-clamp13to18 ltr:[&>h4]:font-LibreBaskervilleRegular rtl:[&>h4]:font-GESSTwoDWTCMedium 
                                  [&>p]:text-clamp12to16 [&>p]:leading-[1.4]
                                  ul-child:ltr:pl-5 p-ul-child:ltr:pl-5 
                                  ul-child:rtl:pr-5 p-ul-child:rtl:pr-5 
                                  li-child:list-disc 
                                  p-li-child:list-disc p-child:text-[#4a4a4a] 
                                  ul-child:text-[#4a4a4a] p-child:font-URWDINRegular
                                  ul-child:font-URWDINRegular ul-child:text-clamp12to16
                                  li-child:pb-1 p-a-child:text-black 
                                  p-a-child:underline
                                  ul-a-child:underline
                                  hover:p-a-child:no-underline
                                      hover:ul-a-child:no-underline
                                  p-child:mb-5 ul-child:mb-5 max-w-[1280px]"
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                faqsQuestionAnswerItemList?.content?.faqAnswer,
                                            }}
                                          />
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              )}
                              {!_.isEmpty(faqsListItem) && (
                                <div className="faq-accordion">
                                  <div
                                    className="faq-questions flex flex-wrap 
                                gap-6 pt-2 border-b border-[#CCC] pb-5 mb-5">
                                    {_.map(faqsListItem, (faqItem, faqIndex) => (
                                      <div
                                        key={faqIndex}
                                        className={` ${activeIndex === faqIndex ? 'text-[#CE445B]' : 'text-[231F20] opacity-50'}
                                      text-[16px] font-medium font-URWDINMedium leading-[1.4] relative cursor-pointer
                                      `}
                                        onClick={() => handleAccordionClick(faqIndex)}>
                                        {getTranslationByKey(
                                          translations,
                                          _.get(faqItem, 'content.itemQuestion'),
                                        )}
                                        {activeIndex === faqIndex && (
                                          <motion.div
                                            className="w-full h-[1px] absolute bottom-[-21px] 
                                        bg-[#CE445B] rounded-sm"
                                            layoutId="underline"
                                          />
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                  {activeIndex !== null && (
                                    <div className="flex flex-col gap-y-3">
                                      {_.map(
                                        faqsListItem[activeIndex].content.itemFaqQuestionAnswer,
                                        (faqsListItemList, faqsListItemIndex) => (
                                          <div
                                            className="flex flex-col gap-y-3"
                                            key={faqsListItemIndex}>
                                            {faqsListItemList?.content?.faqQuestion && (
                                              <h4
                                                className="text-[#58595B]
                                      text-clamp13to18 ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium ">
                                                {faqsListItemList.content.faqQuestion}
                                              </h4>
                                            )}
                                            {faqsListItemList?.content?.faqAnswer && (
                                              <div
                                                className="w-full flex flex-col items-start gap-3 text-[#58595B]
                                                [&>h4]:text-clamp13to18 ltr:[&>h4]:font-LibreBaskervilleRegular rtl:[&>h4]:font-GESSTwoDWTCMedium 
                                                [&>p]:text-clamp12to16 [&>p]:leading-[1.4]
                                                ul-child:ltr:pl-5 p-ul-child:ltr:pl-5 
                                                ul-child:rtl:pr-5 p-ul-child:rtl:pr-5 
                                                li-child:list-disc 
                                                p-li-child:list-disc p-child:text-[#4a4a4a] 
                                                ul-child:text-[#4a4a4a] p-child:font-URWDINRegular
                                                ul-child:font-URWDINRegular ul-child:text-clamp12to16
                                                li-child:pb-1 p-a-child:text-black 
                                                p-a-child:underline
                                                ul-a-child:underline
                                                hover:p-a-child:no-underline
                                                    hover:ul-a-child:no-underline
                                                p-child:mb-5 ul-child:mb-5 max-w-[1280px]"
                                                dangerouslySetInnerHTML={{
                                                  __html: faqsListItemList?.content?.faqAnswer,
                                                }}
                                              />
                                            )}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    )}
                  </>
                ))}
              </div>

              <div className="w-full grid grid-cols-2 gap-3 lg:hidden">
                {_.map(chuckedSm, (pair, index) => (
                  <>
                    {_.map(pair, ([key, items]) => (
                      <button
                        key={key}
                        type="button"
                        onClick={() => handleClick(key, items, index)}
                        className={`text-clamp12to18 ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight m-0
                      tracking-tight leading-1.5 min-h-30 text-center px-3 py-5 relative
                      ${
                        selected[0] === key
                          ? 'bg-red text-white after:content[""] after:block after:w-0 after:h-0 ltr:after:ml-[-7px] after:absolute after:left-1/2 after:top-[calc(100%+16px)] after:border-l-[7px] after:border-l-transparent after:border-b-[6px] after:border-b-red after:border-r-[7px] after:border-r-transparent'
                          : 'bg-white text-red'
                      }`}>
                        <Sprites
                          name={items[0].content.iconName}
                          className={`${
                            selected[0] === key ? '[&>path]:stroke-white' : '[&>path]:stroke-red'
                          } w-8 h-8 mx-auto mb-3`}
                        />
                        {getTranslationByKey(translations,items[0].content.category)}
                      </button>
                    ))}
                    {!_.isEmpty(selected) && index === selected[2] && (
                      <div className="gap-5 col-span-2 p-5 md:p-10 border border-red bg-white flex flex-col my-[10px]">
                        {_.map(selected[1], (item, index2) => {
                          const questionsAnswers = _.get(item, 'content.questionsAnswers', '');
                          const faqsListItem = _.get(item, 'content.faqsListItem', '');
                          return (
                            <React.Fragment key={index2}>
                              {_.isEmpty(questionsAnswers) || (
                                <div
                                  className="w-full flex flex-col items-start gap-3 text-[#58595B]
                                [&>h4]:text-clamp13to18 [&>h4]:font-LibreBaskervilleRegular 
                                [&>p]:text-clamp12to16 ul-child:ltr:pl-5 p-ul-child:ltr:pl-5 
                                ul-child:rtl:pr-5 p-ul-child:rtl:pr-5 
                                li-child:list-disc 
                                p-li-child:list-disc p-child:text-[#4a4a4a] 
                                ul-child:text-[#4a4a4a] p-child:font-URWDINRegular
                                ul-child:font-URWDINRegular ul-child:text-clamp12to16
                                li-child:pb-1 p-a-child:text-black 
                                p-a-child:underline
                                ul-a-child:underline
                                hover:p-a-child:no-underline
                                hover:ul-a-child:no-underline
                                p-child:mb-5 ul-child:mb-5"
                                  dangerouslySetInnerHTML={{ __html: questionsAnswers }}
                                />
                              )}
                              {!_.isEmpty(faqsListItem) && (
                                <div className="faq-accordion">
                                  <div className="faq-questions flex flex-wrap gap-3 md:gap-6 md:pt-9 md:border-b border-[#CCC] pb-5">
                                    {_.map(faqsListItem, (faqItem, faqIndex) => (
                                      <div
                                        key={faqIndex}
                                        className={` ${activeIndex === faqIndex ? 'text-[#CE445B]' : 'text-[231F20] opacity-50'}
                                      text-[14px] md:text-[16px] font-medium font-DINMedium leading-[1.4] relative  cursor-pointer
                                      `}
                                        onClick={() => handleAccordionClick(faqIndex)}>
                                        {_.get(faqItem, 'content.itemQuestion')}
                                        {activeIndex === faqIndex && (
                                          <motion.div
                                            className="w-full h-[1px] absolute bottom-[-21px] bg-[#CE445B] rounded-sm hidden md:block"
                                            layoutId="underline"
                                          />
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                  {activeIndex !== null && (
                                    <div className="flex flex-col gap-y-3">
                                      {_.map(
                                        faqsListItem[activeIndex].content.itemFaqQuestionAnswer,
                                        (faqsListItemList, faqsListItemIndex) => (
                                          <div
                                            className="flex flex-col gap-y-3"
                                            key={faqsListItemIndex}>
                                            {faqsListItemList?.content?.faqQuestion && (
                                              <h4
                                                className="text-[#58595B]
                                      text-clamp13to18 ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium ">
                                                {faqsListItemList.content.faqQuestion}
                                              </h4>
                                            )}
                                            {faqsListItemList?.content?.faqAnswer && (
                                              <div
                                                className="w-full flex flex-col items-start gap-3 text-[#58595B]
                                                [&>h4]:text-clamp13to18 ltr:[&>h4]:font-LibreBaskervilleRegular 
                                                rtl:[&>h4]:font-GESSTwoDWTCMedium 
                                                [&>p]:text-clamp12to16 [&>p]:leading-[1.4]
                                                ul-child:ltr:pl-5 p-ul-child:ltr:pl-5 
                                                ul-child:rtl:pr-5 p-ul-child:rtl:pr-5 
                                                li-child:list-disc 
                                                p-li-child:list-disc p-child:text-[#4a4a4a] 
                                                ul-child:text-[#4a4a4a] p-child:font-URWDINRegular
                                                ul-child:font-URWDINRegular ul-child:text-clamp12to16
                                                li-child:pb-1 p-a-child:text-black 
                                                p-a-child:underline
                                                ul-a-child:underline
                                                hover:p-a-child:no-underline
                                                    hover:ul-a-child:no-underline
                                                p-child:mb-5 ul-child:mb-5 max-w-[1280px]"
                                                dangerouslySetInnerHTML={{
                                                  __html: faqsListItemList?.content?.faqAnswer,
                                                }}
                                              />
                                            )}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default FreeZoneFaq;
